import Vue from 'vue'
import InviteInstance from './src/instance'
import Invite from './src/Index'
Vue.prototype.$showInvite = InviteInstance
export default Invite

